module.exports = __webpack_public_path__ + "b8b500c9249b1969be9c72e2aff4c78d.png";